import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useEquiposAdicionales } from '@/store/erp';

interface ProductModalProps {
}

const ModalCuotas: React.FC<ProductModalProps> = ({ }) => {


  const open = useEquiposAdicionales(s => s.open)
  const setOpen = useEquiposAdicionales(s => s.setOpen)
  //const dataProducto = useEquiposAdicionales(s => s.dataProducto)
  const installmentAmount = useEquiposAdicionales(s => s.installmentAmount)
  const installments = useEquiposAdicionales(s => s.cuotas)
  const ajusteCuota = useEquiposAdicionales(s => s.ajusteCuota)
  const totalPagar = useEquiposAdicionales(s => s.totalPagar)

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={{
        maxHeight: '500px',
        overflow: 'auto',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: 1,
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%'
        }}>
          <Typography id="modal-title" variant="h6" component="h2" gutterBottom>
            Detalles de pago
          </Typography>

          <IconButton
            onClick={() => setOpen(false)}
          >
            <Close />
          </IconButton>

        </div>

        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table aria-label="tabla de cuotas">
            <TableHead>
              <TableRow>
                <TableCell>Cuota</TableCell>
                <TableCell align="right">Monto</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {ajusteCuota>0 && (
                <TableRow>
                  <TableCell component="th" scope="row" sx={{ borderBottom: '1px solid #ccc' }}>
                    1
                  </TableCell>
                  <TableCell align="right" sx={{ borderBottom: '1px solid #ccc' }}>${ajusteCuota.toFixed(2)}</TableCell>
                </TableRow>
              )}
              {Array.from({ length: ( ajusteCuota>0?installments-1:installments) }, (_, index) => (
                <TableRow key={index} >
                  <TableCell component="th" scope="row" sx={{ borderBottom: '1px solid #ccc' }}>
                    {index + (ajusteCuota>0?2:1)}
                  </TableCell>
                  <TableCell align="right" sx={{ borderBottom: '1px solid #ccc' }}>${installmentAmount.toFixed(2)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Typography id="modal-description" sx={{ mt: 2 }}>
          Precio total: ${totalPagar} + Impuesto
        </Typography>

        {/* <Button
          onClick={() => setOpen(false)}
          variant='text'
        >
          Cerrar
        </Button> */}
      </Box>
    </Modal>
  );
};

export default ModalCuotas;

